<template>
  <button
    :type="htmlType"
    :class="classes"
    :disabled="disabled"
    @click="handleClick">
    <slot></slot>
  </button>
</template>

<script>
	import {oneOf} from "@utils/assest";

	const prefixCls = 'e-button';

  export default {
		name: "e-button",
    props: {
      type: {
        validator (value) {
          return oneOf(value, ['default', 'link', 'outlined']);
        },
        default: 'default'
      },
      color: {
        type: String,
        default: 'blue-light'
      },
      size: {
        validator (value) {
          return oneOf(value, ['small', 'smaller', 'large', 'default']);
        },
        default: 'default'
      },
      disabled: Boolean,
      htmlType: {
        default: 'button',
        validator (value) {
          return oneOf(value, ['button', 'submit', 'reset']);
        }
      },
      long: {
        type: Boolean,
        default: false
      },
      shadow: {
        type: Boolean,
        default: null,
      }
    },
    computed: {
      classes () {
        return [
          `${prefixCls}`,
          `${prefixCls}-color-${this.color}`,
          {
            [`${prefixCls}-${this.type}`]: this.type !== 'default',
            [`${prefixCls}-${this.size}`]: this.size !== 'default',
            [`${prefixCls}-long`]: this.long,
            [`${prefixCls}-shadow`]: this.shadow,
            [`${prefixCls}-shadowless`]: this.shadow === false,
            [`${prefixCls}-disabled`]: this.disabled,
          }
        ];
      }
    },
    methods: {
      handleClick (event) {
        this.$emit('click', event);
      }
    },
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/button/button.vue